'use client';
import MobileDrawer from '@c/drawers/MobileDrawer';
import Filters from '@c/filters/Filters';
import CheckboxFilterSection from '@c/filters/sections/CheckboxFilterSection';
import { useCategoryFilters } from '@util/hooks/useCategoryFilters';
import { PageSideFilters } from '@util/hooks/useProductsPage';
import { CategoryDocument } from 'models/category';
import { FacetCounts } from 'models/product';

type MobileSearchFiltersProps = {
  showFilters: boolean;
  setShowFilters: (showFilters: boolean) => void;
  filterState: PageSideFilters;
  setFilterState: (filterState: PageSideFilters) => void;
  allBrands: string[];
  facet_counts: FacetCounts | undefined;
  categories?: CategoryDocument[];
  mostly_parts?: boolean;
};

export default function MobileSearchFilters({
  showFilters,
  setShowFilters,
  filterState,
  setFilterState,
  allBrands,
  facet_counts,
  categories,
  mostly_parts,
}: MobileSearchFiltersProps) {
  const {
    handleFilterChange,
    handleCategoryChange,
    applyPendingFilterChanges,
    pendingFilterChanges,
  } = useCategoryFilters({
    filterState,
    setFilterState,
  });

  return (
    <MobileDrawer
      show={showFilters}
      dismiss={() => setShowFilters(false)}
      title="Filter"
    >
      <div className="max-h-[65rem] overflow-y-auto px-8 pb-[10rem] pt-8">
        <CheckboxFilterSection
          title="Condition"
          filterOptions={['New', 'Used'].map((condition) => ({
            key: condition,
            label: condition,
            value: condition,
          }))}
          onChange={(values) => {
            handleFilterChange('conditions', values);
          }}
          filterState={pendingFilterChanges?.conditions ?? []}
        />
        <Filters
          filterState={pendingFilterChanges}
          handleFilterChange={handleFilterChange}
          handleCategoryChange={handleCategoryChange}
          allBrands={allBrands}
          facet_counts={facet_counts}
          categories={categories}
          mostly_parts={mostly_parts}
        />
      </div>

      <div className="absolute bottom-0 w-full bg-white p-6">
        <button
          type="button"
          className="w-full rounded-[2rem] bg-brand-secondary p-6 text-[2.1rem] font-semibold text-white"
          onClick={() => {
            applyPendingFilterChanges();
            setShowFilters(false);
          }}
        >
          Show Results
        </button>
      </div>
    </MobileDrawer>
  );
}
